import styled from 'styled-components'

import { helpers, toRem } from 'styles'

export const Title = styled.div`
	font-size: ${toRem(18)};
	color: ${helpers.color.itemTitle};
	line-height: ${toRem(24)};
`
